export default __webpack_public_path__ + "static/media/DENTISTCERTIFICATE_EN.def4b20b.png";